import {
  HttpContext,
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { LoadingService } from '../services/loading.service';

/** Flag a request to stay out of the global loading overlay. */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/**
 * Opt a request out of the global overlay — for background/typeahead calls that
 * shouldn't block the UI. Usage: `http.get(url, { context: skipLoading() })`.
 */
export function skipLoading(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_LOADING, true);
}

/** Shows the app-wide overlay while any non-skipped request is in flight. */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loading: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_LOADING)) {
      return next.handle(request);
    }

    this.loading.show();
    return next.handle(request).pipe(finalize(() => this.loading.hide()));
  }
}
